import { Component } from 'react';
import styles from './LoadingComponent.scss';

export class LoadingComponent extends Component {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {
            startingTime: Date.now(),
            parameter: 0,
            phase: 4E-4,
            width: 128,
            height: 128,
            circles: 6,
            colors: [
                '#cc6b0a',
                '#e6780b',
                '#ff860d',
                '#2688ff',
                '#257be6',
                '#1f6acc',
            ],
            text: props.text ? ` ${props.text}` : ' Loading'
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.update();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    update() {
        window.requestAnimationFrame(() => {
            if (!this._isMounted) {
                return;
            }
            const { phase, startingTime } = this.state;
            const timeDelta = Date.now() - startingTime;
            const parameter = (phase * timeDelta) % 1;
            this.setState({parameter});
            this.updateCanvas();
            this.update();
        });
    }

    updateCanvas() {
        const ctx = this.canvas.getContext('2d');
        ctx.font = '16px Hind-Regular';

        const { width, height, circles, colors, parameter, text } = this.state;
        const halfWidth = width / 2;
        const halfHeight = height / 2;

        ctx.clearRect(0, 0, width, height);

        ctx.translate(halfWidth, halfHeight);
        ctx.scale(1, 0.75);
        for (let i = 0; i < circles; i += 1) {
            const angle = (i / circles + parameter) * 2 * Math.PI;
            let x = halfWidth * 0.33 * Math.cos(angle);
            let y = halfHeight * 0.33 * Math.sin(angle);
            let radius = 6 + 2 * Math.sin(angle);
            ctx.fillStyle = colors[i];
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, 2 * Math.PI);
            ctx.closePath();
            ctx.fill();
        }
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        const {width: textWidth} = ctx.measureText(text);
        const {width: textHeight} = ctx.measureText('M');
        ctx.fillStyle = '#8ca0b3';
        ctx.translate((width - textWidth) / 2, height - textHeight);
        ctx.fillText(text, 0, 0);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
    }

    render() {
        const { width, height } = this.state;
        return (
            <div className={styles.loadingDiv}>
                <canvas ref={canvas => this.canvas = canvas} width={width} height={height} />
            </div>
        );
    }
}

export default LoadingComponent;